/**
 * Green Brothers vote: pick a side, share the link, email to confirm.
 */
(() => {
  if (customElements.get('gb-vote')) return;

  class GbVote extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.locale = document.documentElement.lang || 'fr-CA';
      try {
        this.messages = JSON.parse(this.querySelector('[data-gb-vote-i18n]')?.textContent || '{}');
      } catch {
        this.messages = {};
      }

      this.choice = null;
      this.stepDone = this.querySelector('[data-vote-step="done"]');
      this.live = this.querySelector('[data-vote-live]');
      this.remain = this.querySelector('[data-vote-remain]');
      this.titleEl = this.querySelector('[data-vote-title]');
      this.result = this.querySelector('[data-vote-result]');
      this.resultCopy = this.querySelector('[data-vote-result-copy]');
      this.countA = this.querySelector('[data-vote-count-a]');
      this.countB = this.querySelector('[data-vote-count-b]');
      this.pctA = this.querySelector('[data-vote-pct-a]');
      this.pctB = this.querySelector('[data-vote-pct-b]');
      this.forms = this.querySelectorAll('[data-vote-form]');
      this.sides = this.querySelectorAll('.gb-arena__side');
      this.rally = this.querySelector('[data-vote-rally]');
      this.rallyCopy = this.querySelector('[data-vote-rally-copy]');
      this.shareInput = this.querySelector('[data-vote-share-url]');
      this.shareBtn = this.querySelector('[data-vote-share]');

      this.api = (this.getAttribute('data-vote-api') || '').replace(/\/+$/, '');
      this.votesA = Number(this.getAttribute('data-votes-a') || 0);
      this.votesB = Number(this.getAttribute('data-votes-b') || 0);
      this.goal = Math.max(1, Number(this.getAttribute('data-goal') || 1000));
      this.shareBtnLabel = this.shareBtn ? this.shareBtn.textContent : '';

      this.sides.forEach((side) => {
        side.addEventListener('click', () => {
          if (this._done) return;
          this.select(side.getAttribute('data-vote-pick'));
        });
      });

      this.forms.forEach((form) => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.submitForm(form);
        });
        const email = form.querySelector('[data-vote-email]');
        if (email) {
          email.addEventListener('input', () => this.clearError());
        }
      });

      if (this.shareBtn) {
        this.shareBtn.addEventListener('click', () => this.copyShare());
      }
      if (this.shareInput) {
        this.shareInput.addEventListener('focus', () => this.shareInput.select());
      }

      this.prepareEntrance();
      this.applyUrlPick();
      this.loadScore();
    }

    savedPick() {
      try {
        const pick = localStorage.getItem('gb-vote-pick') || '';
        return pick === 'a' || pick === 'b' ? pick : '';
      } catch (err) {
        return '';
      }
    }

    storedCampaign() {
      try {
        return localStorage.getItem('gb-vote-campaign') || '';
      } catch (err) {
        return '';
      }
    }

    rememberPick(pick) {
      if (pick !== 'a' && pick !== 'b') return;
      try {
        localStorage.setItem('gb-vote-pick', pick);
        localStorage.setItem('gb-vote-campaign', this.campaign || '');
      } catch (err) {}
    }

    clearStoredVote() {
      try {
        localStorage.removeItem('gb-vote-pick');
        localStorage.removeItem('gb-vote-campaign');
        localStorage.removeItem('gb-vote-emails');
      } catch (err) {}
    }

    reopen() {
      this._done = false;
      this._busy = false;
      this.classList.remove('is-voted', 'has-pick', 'has-pick-a', 'has-pick-b', 'is-busy');
      this.removeAttribute('aria-busy');
      if (this.stepDone) {
        this.stepDone.hidden = true;
        this.stepDone.classList.remove('is-from-a', 'is-from-b');
      }
      this.forms.forEach((form) => {
        form.querySelectorAll('input, button').forEach((el) => {
          el.disabled = false;
        });
      });
    }

    async loadScore() {
      try {
        if (this.api) {
          const res = await fetch(`${this.api}/score`);
          if (res.ok) this.applyScore(await res.json());
        }
      } catch (err) {}
      this.restoreThanks();
    }

    restoreThanks() {
      if (this.winner) return;
      const pick = this.savedPick();
      const stored = this.storedCampaign();
      if (!this.campaign || !stored || stored !== this.campaign) {
        if (pick || stored) this.clearStoredVote();
      }
    }

    showThanks(pick, options = {}) {
      const known = pick === 'a' || pick === 'b' ? pick : '';
      const name = known ? this.pickName(known) : '';
      this.classList.remove('is-busy');
      this.removeAttribute('aria-busy');
      if (known) {
        this.classList.add('has-pick', known === 'b' ? 'has-pick-b' : 'has-pick-a');
        this.sides.forEach((side) => {
          side.classList.toggle('is-selected', side.getAttribute('data-vote-pick') === known);
        });
      }
      if (this.stepDone) {
        this.stepDone.hidden = false;
        this.stepDone.classList.toggle('is-from-a', known === 'a');
        this.stepDone.classList.toggle('is-from-b', known === 'b');
      }

      const other = known === 'b' ? this.pickName('a') : known === 'a' ? this.pickName('b') : '';
      const copy = this.querySelector('[data-vote-thanks]');
      const already = Boolean(options.already);
      if (copy) {
        copy.replaceChildren();
        if (already || !name) {
          copy.textContent =
            this.getAttribute('data-thanks-already') || this.messages.already;
        } else {
          const lead = document.createElement('span');
          lead.textContent = `${this.getAttribute('data-thanks-lead') || this.messages.thanksLead} `;
          const picked = document.createElement('strong');
          picked.className = 'gb-hero__done-name';
          picked.setAttribute('data-vote-team', known);
          picked.textContent = name;
          const mid = document.createElement('span');
          mid.textContent = `${this.getAttribute('data-thanks-mid') || this.messages.thanksMid} `;
          const loser = document.createElement('strong');
          loser.className = 'gb-hero__done-other';
          loser.setAttribute('data-vote-team', known === 'a' ? 'b' : 'a');
          loser.textContent = other;
          const end = document.createElement('span');
          end.textContent = '.';
          copy.append(lead, picked, mid, loser, end);
        }
      }

      if (this.remain) {
        this.remain.replaceChildren();
        // The remaining count would disclose the team's total after voting.
        this.remain.hidden = true;
      }

      const ig = this.querySelector('.gb-hero__done-ig');
      this.syncPickButtons();
      const spoken = [copy, this.remain, ig]
        .filter((el) => el && !el.hidden)
        .map((el) => el.textContent.trim())
        .filter(Boolean)
        .join(' ');
      if (this.live) this.live.textContent = spoken;
      if (options.scroll && this.stepDone && !this.reduceMotion()) {
        this.stepDone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    applyScore(data) {
      if (!data || typeof data !== 'object') return;
      if (Number.isFinite(Number(data.a))) this.votesA = Number(data.a);
      if (Number.isFinite(Number(data.b))) this.votesB = Number(data.b);
      if (Number.isFinite(Number(data.goal)) && Number(data.goal) > 0) {
        this.goal = Number(data.goal);
      }
      if (data.winner === 'a' || data.winner === 'b') this.winner = data.winner;
      else if (Object.prototype.hasOwnProperty.call(data, 'winner')) this.winner = '';
      if (data.campaign) this.campaign = String(data.campaign);
      this.syncBoard();
      if (this.winner) this.markClosed();
    }

    markClosed() {
      const name = this.pickName(this.winner);
      this._done = true;
      this.classList.remove('has-pick', 'has-pick-a', 'has-pick-b');
      this.classList.add('is-won', this.winner === 'b' ? 'is-won-b' : 'is-won-a');
      this.sides.forEach((side) => {
        const pick = side.getAttribute('data-vote-pick');
        const won = pick === this.winner;
        side.classList.toggle('is-winner', won);
        side.classList.toggle('is-selected', won);
      });
      this.querySelectorAll('[data-vote-badge]').forEach((badge) => {
        badge.hidden = badge.getAttribute('data-vote-badge') !== this.winner;
      });
      if (this.titleEl) {
        const tpl = this.getAttribute('data-winner-heading') || this.messages.winnerHeading;
        this.titleEl.textContent = tpl.replace('%n%', name);
      }
      if (this.result) this.result.hidden = false;
      if (this.resultCopy) {
        const tpl = this.getAttribute('data-winner') || this.messages.winner;
        this.resultCopy.textContent = tpl.replace('%n%', name);
      }
      if (this.rally) this.rally.hidden = true;
      if (this.stepDone) this.stepDone.hidden = true;
      this.lockForms();
      this.syncPickButtons();
      document.querySelectorAll('.gb-vote-btn').forEach((btn) => {
        btn.textContent = this.messages.result;
      });
      if (this.live) this.live.textContent = this.titleEl ? this.titleEl.textContent : name;
    }

    reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    prepareEntrance() {
      if (
        this.reduceMotion() ||
        window.matchMedia('(max-width: 749px)').matches
      ) {
        this.classList.add('is-in');
        this.syncBoard();
        return;
      }

      this.classList.add('is-ready');
      this.style.setProperty('--fill-a', '0');
      this.style.setProperty('--fill-b', '0');

      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.classList.add('is-in');
          window.setTimeout(() => this.syncBoard(), 1180);
          io.disconnect();
        },
        { threshold: 0.28, rootMargin: '0px 0px -6% 0px' }
      );

      io.observe(this);
    }

    applyUrlPick() {
      const pick = new URLSearchParams(window.location.search).get('pick');
      if (pick === 'a' || pick === 'b') this.select(pick);
    }

    fillRatio(votes) {
      return Math.max(0, Math.min(1, votes / this.goal));
    }

    pctOfGoal(votes) {
      return Math.round(this.fillRatio(votes) * 100);
    }

    syncBoard() {
      this.syncPickButtons();
      this.style.setProperty('--fill-a', String(this.fillRatio(this.votesA)));
      this.style.setProperty('--fill-b', String(this.fillRatio(this.votesB)));

      if (this.countA) {
        this.countA.hidden = !this.winner;
        this.countA.textContent = this.votesA.toLocaleString(this.locale);
      }
      if (this.countB) {
        this.countB.hidden = !this.winner;
        this.countB.textContent = this.votesB.toLocaleString(this.locale);
      }
      // Only the numbers stay hidden during the campaign. Gauges remain
      // visible and continue to show each team's progress toward the goal.
      this.querySelectorAll('[data-vote-results]').forEach((element) => {
        element.hidden = !this.winner;
      });
      if (this.pctA) {
        this.pctA.hidden = !this.winner;
        this.pctA.textContent = `${this.pctOfGoal(this.votesA)}%`;
      }
      if (this.pctB) {
        this.pctB.hidden = !this.winner;
        this.pctB.textContent = `${this.pctOfGoal(this.votesB)}%`;
      }
    }

    pickName(pick) {
      return this.getAttribute(pick === 'b' ? 'data-name-b' : 'data-name-a') || '';
    }

    syncPickButtons() {
      this.querySelectorAll('[data-vote-select]').forEach((button) => {
        const side = button.closest('.gb-arena__side');
        button.setAttribute('aria-pressed', String(side?.classList.contains('is-selected') || false));
        button.disabled = Boolean(this._done || this.winner);
      });
    }

    shareUrl(pick) {
      const url = new URL(window.location.href);
      url.searchParams.set('pick', pick);
      url.hash = 'vote';
      return url.toString();
    }

    select(pick) {
      if (this._done || this.winner) return;
      if (!pick || (pick !== 'a' && pick !== 'b')) return;
      this.choice = pick;
      this.classList.add('has-pick');
      this.classList.toggle('has-pick-a', pick === 'a');
      this.classList.toggle('has-pick-b', pick === 'b');
      this.sides.forEach((side) => {
        side.classList.toggle('is-selected', side.getAttribute('data-vote-pick') === pick);
      });
      this.syncShare();
      this.syncPickButtons();
    }

    syncShare() {
      if (!this.choice || !this.rally) return;
      const name = this.pickName(this.choice);
      const url = this.shareUrl(this.choice);
      const tpl = this.getAttribute('data-share-prompt') || this.messages.sharePrompt;
      if (this.rallyCopy) this.rallyCopy.textContent = tpl.replace('%n%', name);
      if (this.shareInput) this.shareInput.value = url;
      if (this.shareBtn) {
        this.shareBtn.textContent = this.shareBtnLabel;
        this.shareBtn.classList.remove('is-copied');
      }
      this.rally.hidden = false;
    }

    async copyShare() {
      if (!this.choice || !this.shareInput) return;
      const url = this.shareUrl(this.choice);
      this.shareInput.value = url;
      try {
        await navigator.clipboard.writeText(url);
        this.markCopied();
      } catch (err) {
        this.shareInput.focus();
        this.shareInput.select();
        try {
          document.execCommand('copy');
          this.markCopied();
        } catch (copyErr) {
          if (this.live) this.live.textContent = url;
        }
      }
    }

    markCopied() {
      const msg = this.getAttribute('data-share-copied') || this.messages.shareCopied;
      if (this.shareBtn) {
        this.shareBtn.textContent = msg;
        this.shareBtn.classList.add('is-copied');
        window.setTimeout(() => {
          if (!this.shareBtn) return;
          this.shareBtn.textContent = this.shareBtnLabel;
          this.shareBtn.classList.remove('is-copied');
        }, 1800);
      }
      if (this.live) this.live.textContent = msg;
    }

    votedEmails() {
      try {
        const raw = localStorage.getItem('gb-vote-emails');
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (err) {
        return [];
      }
    }

    rememberEmail(email) {
      const next = [...new Set([...this.votedEmails(), email])];
      try {
        localStorage.setItem('gb-vote-emails', JSON.stringify(next));
      } catch (err) {}
    }

    lockForms() {
      this.forms.forEach((other) => {
        other.querySelectorAll('input, button').forEach((el) => {
          el.disabled = true;
        });
      });
    }

    showError(message, form) {
      const text = message || '';
      this.querySelectorAll('[data-vote-error]').forEach((el) => {
        const mine = !form || form.contains(el);
        if (mine && text) {
          el.hidden = false;
          el.textContent = text;
        } else {
          el.hidden = true;
          el.textContent = '';
        }
      });
      if (this.live) this.live.textContent = text;
    }

    clearError() {
      this.showError('');
    }

    finish(pick, score) {
      if (score) this.applyScore(score);
      else if (pick === 'a') this.votesA += 1;
      else if (pick === 'b') this.votesB += 1;
      this.syncBoard();
      if (this.winner) {
        this.rememberPick(pick);
        return;
      }
      this.rememberPick(pick);
      this.showThanks(pick, { scroll: true });
    }

    async submitForm(form) {
      if (this._done || this._busy) return;
      this._busy = true;

      const pick = form.getAttribute('data-vote-pick');
      this.select(pick);

      const input = form.querySelector('[data-vote-email]');
      if (!input || !input.value || !input.validity.valid) {
        this._busy = false;
        if (input) input.reportValidity();
        return;
      }

      const email = input.value.trim().toLowerCase();
      if (!this.api && this.votedEmails().includes(email)) {
        this._busy = false;
        this.rememberEmail(email);
        this.showThanks(this.savedPick() || pick, { already: true, scroll: true });
        return;
      }

      const button = form.querySelector('button[type="submit"]');
      const pending = this.getAttribute('data-pending') || this.messages.pending;
      const buttonLabel = button ? button.textContent : '';
      this.forms.forEach((other) => {
        other.querySelectorAll('input, button').forEach((el) => {
          el.disabled = true;
        });
      });
      if (button) {
        button.textContent = pending;
        button.classList.add('is-busy');
      }
      this.classList.add('is-busy');
      this.setAttribute('aria-busy', 'true');
      if (this.live) this.live.textContent = pending;
      this.clearError();

      const release = () => {
        this.classList.remove('is-busy');
        this.removeAttribute('aria-busy');
        if (this._done) return;
        this.forms.forEach((other) => {
          other.querySelectorAll('input, button').forEach((el) => {
            el.disabled = false;
          });
        });
        if (button) {
          button.textContent = buttonLabel;
          button.classList.remove('is-busy');
        }
      };

      try {
        let score = null;
        if (this.api) {
          const res = await fetch(`${this.api}/vote`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ email, pick }),
          });
          const data = await res.json().catch(() => ({}));
          if (data && (data.a != null || data.b != null)) score = data;
          if (data.closed) {
            this.applyScore(score);
            this._busy = false;
            release();
            return;
          }
          if (res.status === 409 || data.already) {
            this.applyScore(score);
            this._busy = false;
            if (data.closed || this.winner) {
              release();
              return;
            }
            release();
            this.showError(
              this.getAttribute('data-thanks-already') || this.messages.already,
              form
            );
            return;
          }
          if (!res.ok) throw new Error('vote_failed');
        }
        this.rememberEmail(email);
        this.finish(pick, score);
        if (input) input.value = '';
        this._busy = false;
        release();
        if (typeof window.gbAcSubmit === 'function') {
          window.gbAcSubmit({
            source: 'vote',
            email,
            pick,
            vote: this.pickName(pick),
            message: `Vote ${this.pickName(pick)}`,
          }).catch(() => {});
        }
      } catch (err) {
        this._busy = false;
        release();
        this.showError(this.messages.error, form);
      }
    }
  }

  customElements.define('gb-vote', GbVote);
})();
